export type EnrichmentCostType = 'standard' | 'phone';

export const DEFAULT_CREDIT_COSTS: Record<EnrichmentCostType, number> = {
  standard: 1,
  phone: 10,
};

export function getCostPerContact(
  costs: Record<string, number> | undefined,
  type: EnrichmentCostType
): number {
  const v = costs?.[type];
  return typeof v === 'number' && Number.isFinite(v) && v > 0
    ? v
    : DEFAULT_CREDIT_COSTS[type];
}

export function estimateCreditCost(
  count: number,
  costs: Record<string, number> | undefined,
  type: EnrichmentCostType
): number {
  return Math.max(0, count) * getCostPerContact(costs, type);
}

/** Pluralize a credit count: 1 -> "1 credit", else "N credits". */
export function formatCredits(n: number): string {
  return `${n} ${n === 1 ? 'credit' : 'credits'}`;
}
